import { render, staticRenderFns } from "./TestsTodo.vue?vue&type=template&id=51834576"
import script from "./TestsTodo.vue?vue&type=script&lang=js"
export * from "./TestsTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports